{
  "defaults": {
    "printFailed": "Không thể in PDF",
    "downloadFailed": "Không thể tải PDF",
    "downloadSuccess": "Đã tải PDF thành công"
  }
}
